import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronLeft, GraduationCap, Trophy, Flame, Brain, Layers, ClipboardCheck, ChevronRight } from "lucide-react";
import api from "../lib/api";
import { useT } from "../context/LanguageContext";
import TopBar from "../components/TopBar";

export default function Progress() {
  const navigate = useNavigate();
  const tr = useT();
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/dashboard/stats").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="space-bg min-h-screen flex items-center justify-center text-white/60">{tr("Caricamento...")}</div>;
  const t = data.totals;

  const Stat = ({ icon: Icon, color, value, label, testid }) => (
    <div className="glass rounded-2xl p-4 text-center" data-testid={testid}>
      <Icon size={22} style={{ color }} className="mx-auto mb-1" />
      <div className="font-num font-bold text-2xl">{value}</div>
      <div className="text-xs text-white/50">{label}</div>
    </div>
  );

  return (
    <div className="space-bg min-h-screen pb-16">
      <TopBar />
      <div className="max-w-2xl mx-auto px-4 pt-6">
        <button onClick={() => navigate("/dashboard")} className="flex items-center gap-1 text-white/60 bouncy mb-4" data-testid="progress-back-btn">
          <ChevronLeft size={18} /> {tr("Home")}
        </button>
        <h1 className="font-heading font-black text-3xl tracking-tight flex items-center gap-2 mb-6"><Layers style={{ color: "var(--cyan)" }} /> {tr("Cruscotto Progressi")}</h1>

        <div className="glass rounded-3xl p-5 mb-6" data-testid="overall-progress">
          <div className="flex justify-between mb-2"><span className="font-heading font-bold">{tr("Avanzamento livelli")}</span><span className="font-num" style={{ color: "var(--cyan)" }}>{t.overall_progress}%</span></div>
          <div className="h-3 rounded-full bg-black/40 overflow-hidden"><div className="h-full rounded-full" style={{ width: `${t.overall_progress}%`, background: "var(--cyan)", boxShadow: "0 0 10px var(--cyan)" }} /></div>
          <p className="text-xs text-white/50 mt-2 font-num">{t.completed_levels}/{t.levels} {tr("livelli completati · ")}{t.topics} {tr("argomenti")}</p>
        </div>

        <div className="grid grid-cols-3 gap-3 mb-6">
          <Stat icon={GraduationCap} color="var(--success)" value={t.exams} label={tr("Esami")} testid="stat-exams" />
          <Stat icon={Flame} color="#FF7A00" value={data.user.streak} label={tr("Streak")} testid="stat-streak2" />
          <Stat icon={Trophy} color="var(--gold)" value={`${t.badges}/${t.badges_total}`} label={tr("Trofei")} testid="stat-badges" />
          <Stat icon={ClipboardCheck} color="var(--pink)" value={t.simulations} label={tr("Simulazioni")} testid="stat-sims" />
          <Stat icon={Brain} color="var(--violet)" value={t.reviews_due} label={tr("da ripassare")} testid="stat-reviews" />
          <Stat icon={Layers} color="var(--cyan)" value={`Lv ${data.user.level}`} label={tr("Livello")} testid="stat-lvl" />
        </div>

        <h2 className="font-heading font-bold text-lg tracking-tight mb-3">{tr("Per esame")}</h2>
        {data.exams.length === 0 ? <p className="text-white/50 text-center py-6">{tr("Nessun esame ancora.")}</p> : (
          <div className="space-y-3">
            {data.exams.map((e) => (
              <button key={e.exam_id} onClick={() => navigate(`/exam/${e.exam_id}`)} className="w-full glass rounded-2xl p-4 text-left bouncy flex items-center gap-3" data-testid={`progress-exam-${e.exam_id}`}>
                <div className="flex-1">
                  <div className="flex justify-between items-center mb-1">
                    <h3 className="font-heading font-bold tracking-tight">{e.name}</h3>
                    {e.best_sim != null && <span className="text-xs font-num" style={{ color: "var(--gold)" }}>{tr("Miglior sim: ")}{Math.round(e.best_sim / 100 * 30)}/30</span>}
                  </div>
                  <div className="h-2 rounded-full bg-black/40 overflow-hidden"><div className="h-full rounded-full" style={{ width: `${e.progress}%`, background: "var(--success)" }} /></div>
                  <span className="text-xs text-white/40 font-num">{e.completed}/{e.levels} {tr("livelli")} · {e.topics} {tr("argomenti")}</span>
                </div>
                <ChevronRight size={18} className="text-white/40" />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
